import { useDraggable } from "@dnd-kit/core";
import { FooterButton, type FooterDensity } from "../FooterButton";
import type { FooterBarItem, FooterDragData } from "./footerPinning";
import type { FooterItemState } from "./useFooterDrag";

interface PinnedFooterActionProps {
  item: FooterBarItem;
  state: FooterItemState;
  density: FooterDensity;
  /** Влачи се само докато „Опции" е отворен — иначе е обикновен бутон и
   *  сервитьорът не може да го измести случайно. */
  draggable: boolean;
}

/**
 * Действие от „Опции", изнесено в лентата под масите — същият `FooterButton`
 * като основните. Обвивката е дръжката за влачене: при отворени „Опции"
 * недостъпният бутон е `pointer-events-none`, за да може и той да се хване и
 * върне (disabled бутонът не получава mouse събития).
 */
export const PinnedFooterAction = ({
  item,
  state,
  density,
  draggable,
}: PinnedFooterActionProps) => {
  const dragData: FooterDragData = { actionKey: item.key, source: "footer" };
  const { setNodeRef, listeners } = useDraggable({
    id: `footer:${item.key}`,
    data: dragData,
    disabled: !draggable,
  });

  const stateClass =
    state === "placeholder"
      ? "rounded-[13px] outline-2 outline-dashed outline-offset-2 outline-pos-accent opacity-50 [&_*]:pointer-events-none"
      : "";

  return (
    <div
      ref={setNodeRef}
      data-footer-item={item.key}
      {...(draggable ? listeners : undefined)}
      className={`${state === "hidden" ? "hidden" : "flex"} min-w-0 ${
        density === "squeeze" ? "shrink" : "shrink-0"
      } ${
        draggable
          ? "select-none [-webkit-touch-callout:none] [&_button:disabled]:pointer-events-none"
          : ""
      } ${stateClass}`}
    >
      <FooterButton {...item.button} density={density} />
    </div>
  );
};
